import { ERulerActionType } from './types';
import { actionGenerator } from '../../../common/utils/redux/actionGenerator';

export const enableRuler = actionGenerator<ERulerActionType.RulerEnabled>(ERulerActionType.RulerEnabled);
